/* One continuous selection overlay per group. No duplicated material or render loop. */
(() => {
 const root=document.querySelector('vorug-infinite-collection[data-ui="2"]');
 if(!root)return;
 const borders=new URLSearchParams(location.search).get("borders");
 if(["corners","handdrawn"].includes(borders))root.dataset.borders=borders;
 const groups=[root.querySelector('[data-filter="style"]'),root.querySelector('[data-filter="shape"]'),root.querySelector('[data-filter="color"]')];
 let frame=0;
 const update=()=>{
  frame=0;
  for(const group of groups){
   let lens=group.querySelector('.vic-selection-lens');
   if(!lens){lens=document.createElement('span');lens.className='vic-selection-lens';lens.setAttribute('aria-hidden','true');group.append(lens);group.setAttribute('data-lens-ready','');}
   const selected=group.querySelector('button[aria-pressed="true"]');
   lens.hidden=!selected;if(!selected)continue;
   lens.style.width=`${selected.offsetWidth}px`;lens.style.height=`${selected.offsetHeight}px`;
   lens.style.transform=`translate3d(${selected.offsetLeft}px,${selected.offsetTop}px,0)`;
  }
 };
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(update)};
 const observer=new MutationObserver(schedule);
 for(const group of groups)observer.observe(group,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-pressed','data-overflow']});
 const resize=new ResizeObserver(schedule);for(const group of groups)resize.observe(group);
 document.fonts.ready.then(schedule);update();
 window.addEventListener('pagehide',()=>{observer.disconnect();resize.disconnect();cancelAnimationFrame(frame)},{once:true});
 window.addEventListener('pageshow',e=>{if(e.persisted){for(const group of groups){observer.observe(group,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-pressed','data-overflow']});resize.observe(group)}schedule()}});
})();
